import type { VergeOption } from "../types";
import type { Batten } from "../types/roof";

type VergeQuantity = {
  leftVergeTileType7: number;
  rightVergeTileType7: number;
  leftVergeTileType9: number;
  rightVergeTileType9: number;
  leftVergeTileType11: number;
  rightVergeTileType11: number;
};

const getVergeQuantity = (
  quantities?: Partial<VergeQuantity>
): VergeQuantity => ({
  leftVergeTileType7: 0,
  rightVergeTileType7: 0,
  leftVergeTileType9: 0,
  rightVergeTileType9: 0,
  leftVergeTileType11: 0,
  rightVergeTileType11: 0,
  ...quantities
});

const getVergeTiles = (
  vergeOption: VergeOption,
  sides: Batten["sides"],
  battenSpacing: number
): VergeQuantity => {
  const [leftBattenSide, rightBattenSide] = sides;

  if (leftBattenSide !== "VERGE" && rightBattenSide !== "VERGE") {
    return getVergeQuantity();
  }

  const hasType7VergeTiles =
    vergeOption.rightVergeTileType7 && vergeOption.leftVergeTileType7;
  const hasType9VergeTiles =
    vergeOption.rightVergeTileType9 && vergeOption.leftVergeTileType9;
  let leftVergeTileType9 = 0;
  let rightVergeTileType9 = 0;

  if (
    battenSpacing >= 36 &&
    battenSpacing <= 37 &&
    (hasType7VergeTiles || hasType9VergeTiles)
  ) {
    let leftVergeTileType7 = 0;
    let rightVergeTileType7 = 0;

    if (leftBattenSide === "VERGE") {
      if (hasType7VergeTiles) {
        leftVergeTileType7++;
      } else {
        leftVergeTileType9++;
      }
    }

    if (rightBattenSide === "VERGE") {
      if (hasType7VergeTiles) {
        rightVergeTileType7++;
      } else {
        rightVergeTileType9++;
      }
    }

    return getVergeQuantity({
      leftVergeTileType7,
      rightVergeTileType7,
      leftVergeTileType9,
      rightVergeTileType9
    });
  }

  if (battenSpacing >= 34 && battenSpacing < 36 && hasType9VergeTiles) {
    if (leftBattenSide === "VERGE") {
      leftVergeTileType9++;
    }

    if (rightBattenSide === "VERGE") {
      rightVergeTileType9++;
    }

    return getVergeQuantity({
      leftVergeTileType9,
      rightVergeTileType9
    });
  }

  let leftVergeTileType11 = 0;
  let rightVergeTileType11 = 0;

  if (leftBattenSide === "VERGE") {
    leftVergeTileType11++;
  }

  if (rightBattenSide === "VERGE") {
    rightVergeTileType11++;
  }

  return getVergeQuantity({
    leftVergeTileType11,
    rightVergeTileType11
  });
};

export default getVergeTiles;
